import { useContext } from 'react';
import { ServerStateContext } from './ServerStateContext';

export const useServerState = () => {
  const serverState = useContext(ServerStateContext);

  if (!serverState) {
    throw new Error('Server state context is not initialized!');
  }

  return serverState;
};
